import { Autocomplete, createFilterOptions, TextField } from '@mui/material'
import { useFocoCampo } from '@/hooks'
import { segmentos_api } from '@/service/api'
import { useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

type Opcao = string | { inputValue: string; label: string }

const filtro = createFilterOptions<Opcao>()

interface IProps {
    /** Caminho do campo no react-hook-form. Padrão: "Segmento.nome" */
    name?: string
    /** Desabilita apenas esta instância, além do disabled global do form */
    disabled?: boolean
    /** Chamado com o nome escolhido sempre que o valor muda (seleção real, não a cada tecla) */
    onSelecionar?: (nome: string) => void
    /** Padrão true. Usar false quando o campo pode ficar vazio (ex.: seleção em lote, item por item) */
    required?: boolean
}

export function AutocompleteSegmento({
    name = 'Segmento.nome',
    disabled: disabledProp,
    onSelecionar,
    required = true,
}: IProps) {
    const {
        control,
        control: {
            _options: { disabled: disabledForm },
        },
    } = useFormContext()

    const { ref: inputRef, deveFocar } = useFocoCampo('Segmento')
    const [inputValue, setInputValue] = useState('')

    const { data: segmentos = [] } = segmentos_api.useFetch({
        enabled: true,
        refetchOnWindowFocus: false,
    })

    const nomes = segmentos.map(segmento => segmento.nome)

    return (
        <Controller
            name={name}
            control={control}
            rules={required ? { required: 'Obrigatório' } : undefined}
            render={({ field: { value, onChange }, fieldState: { error } }) => (
                <Autocomplete
                    disabled={disabledForm || disabledProp}
                    freeSolo
                    options={nomes}
                    value={value || null}
                    inputValue={inputValue}
                    onInputChange={(_, novoValor) => setInputValue(novoValor)}
                    onChange={(_, novoValor) => {
                        const nome = !novoValor
                            ? ''
                            : typeof novoValor === 'string'
                              ? novoValor
                              : novoValor.inputValue
                        onChange(nome)
                        if (nome) onSelecionar?.(nome)
                    }}
                    filterOptions={(options, params) => {
                        const filtered = filtro(options, params)
                        const jaExiste = options.some(
                            opcao =>
                                opcao.toLowerCase() ===
                                params.inputValue.toLowerCase(),
                        )
                        if (params.inputValue !== '' && !jaExiste) {
                            filtered.push({
                                inputValue: params.inputValue,
                                label: `Outro: ${params.inputValue}`,
                            })
                        }
                        return filtered
                    }}
                    getOptionLabel={opcao =>
                        typeof opcao === 'string' ? opcao : opcao.label
                    }
                    isOptionEqualToValue={(opcao, valorAtual) =>
                        (typeof opcao === 'string' ? opcao : opcao.label) ===
                        valorAtual
                    }
                    renderInput={props => (
                        <TextField
                            {...props}
                            inputRef={inputRef}
                            variant="filled"
                            label="Segmento"
                            placeholder="Digite o segmento"
                            required={required}
                            error={!!error}
                            helperText={
                                error?.message ??
                                (deveFocar
                                    ? 'Por favor, incluir o segmento.'
                                    : undefined)
                            }
                        />
                    )}
                />
            )}
        />
    )
}
